import { mapState } from 'vuex';
import get from 'lodash/get';
import UpsertDashboardDialog from './upsertDashboardDialog.vue';
import cloneDeep from 'lodash/cloneDeep';
import dateTimeMixin from '@/mixins/date-time';
export default {
  name: 'Toolbar',
  components: {
    UpsertDashboardDialog
  },
  mixins: [dateTimeMixin],
  props: {
    dateRange: {
      type: Object,
      required: true
    },
    loadingWidgetData: {
      type: Boolean,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    },
    dashboardLayers: {
      type: Array,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showFullScreenButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showEditModeButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showDateRangePicker: false,
      nextDashboardName: null,
      isSavingDashboardName: false,
      dashboardNameSaveError: null,
      showEditDashboardDialog: false
    };
  },
  computed: {
    ...mapState('dashboards', ['dashboards']),
    ...mapState('app', ['color', 'inpOutlined']),
    editModeSwitchValue: {
      get() {
        return this.editMode;
      },
      set(value) {
        this.$emit('update:edit-mode', value);
      }
    },
    activeDashboardLayer() {
      const activeLayer = this.dashboardLayers[this.dashboardLayers.length - 1];
      return activeLayer;
    },
    activeDashboard() {
      return this.dashboards.find(dashboard => dashboard.id === this.activeDashboardLayer.dashboardId);
    },
    breadCrumbItems() {
      return this.dashboardLayers.map((layer, index) => {
        const dashboard = this.dashboards.find(dashboard => dashboard.id === layer.dashboardId);
        const dashboardName = get(dashboard, 'meta.name', '...');
        const dashboardParams = cloneDeep(get(dashboard, 'parameters', {}));
        const layerParams = cloneDeep(get(layer, 'customParameters', {}));
        const fullParameters = {
          ...dashboardParams,
          ...layerParams
        };
        let dashboardNameWithParameters = dashboardName;
        Object.entries(fullParameters).forEach(([key, value]) => {
          dashboardNameWithParameters = dashboardNameWithParameters.replace(`{{${key}}}`, value);
        });
        return {
          text: dashboardNameWithParameters,
          dashboardId: layer.dashboardId,
          layerIdx: index,
          disabled: index === this.dashboardLayers.length - 1,
          isActiveLayer: index === this.dashboardLayers.length - 1
        };
      });
    },
    dateRangeLabel() {
      return this.$t('Dashboards.components.toolbar.dateRangeLabel.text', {
        start: this.formatDateTime(this.dateRange.start),
        end: this.formatDateTime(this.dateRange.end)
      });
    }
  },
  methods: {
    onDateRangePicked(dateObject) {
      const start = new Date(dateObject.from * 1000);
      const end = new Date(dateObject.to * 1000);
      this.$emit('update:date-range', {
        start,
        end
      });
    },
    async saveDashboardName() {
      this.isSavingDashboardName = true;
      const {
        success,
        error
      } = await this.$store.dispatch('dashboards/changeDashboardConfig', {
        dashboardId: this.activeDashboardLayer.dashboardId,
        name: this.nextDashboardName
      });
      this.isSavingDashboardName = false;
      if (!success) {
        console.error('error', error);
        this.$snack(this.$t('Dashboards.components.toolbar.error.savingDashboardName'), 'error');
      }
    },
    handleApplyAndSaveClick(apply) {
      apply();
      this.$emit('click:save-default-date-range');
    }
  }
};